import type {
  BillingContext, BillingPortalFlow, UpdateBillingInput,
} from '@/models/billing';

import { client } from './client';

interface AvailableSeatsResponse {
  availableSeats: number;
}

export const billingService = {
  async getAvailableSeats(): Promise<number> {
    const { availableSeats } = await client.get<AvailableSeatsResponse>('/billing/available_seats');
    return availableSeats;
  },

  getBillingContext(): Promise<BillingContext> {
    return client.get('/billing/context');
  },

  getBillingPortalUrl(flow?: BillingPortalFlow): Promise<string> {
    return client.get(flow ? `/billing/portal?flow=${flow}` : '/billing/portal');
  },

  bookSeats(input: UpdateBillingInput) {
    return client.put('/billing', input);
  },
};
